memoizedSelector